import { Dispatch } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as ENDPOINTS from './endpoints';
import { GoalsAction, GoalsActionTypes } from '../reducer/goals.reducer';
import { useCustomMutation } from '@devd-client/devd/components';
import { AllGoalsResponse } from '../helpers/goals.types';

export const QUERY_KEYS = {
  goals: 'goals',
  goalsPage: 'goalsPage',
  teams: 'teams',
  members: 'members',
  metricsList: 'metricsList',
};

export const useGetGoals = (team: string, dispatch: Dispatch<GoalsAction>) => {
  return useQuery<AllGoalsResponse>(
    [QUERY_KEYS.goals, team],
    () => ENDPOINTS.getAllGoals(team),
    {
      onSuccess: (data: AllGoalsResponse) => {
        dispatch({
          type: GoalsActionTypes.GET_GOALS_LIST,
          payload: data?.dto,
        });
      },
    }
  );
};

export const useGoalSettingsMutation = () => {
  return useCustomMutation([QUERY_KEYS.goals], ENDPOINTS.updateGoalSettings);
};

export const useGoalsPage = () => {
  return useQuery([QUERY_KEYS.goalsPage], ENDPOINTS.getGoalsPage);
};

//New API's
export const useGetTeams = () => {
  return useQuery([QUERY_KEYS.teams], ENDPOINTS.getTeams);
};

export const useGetMetricsList = () => {
  return useQuery([QUERY_KEYS.metricsList], ENDPOINTS.getMetricsList);
};

export const useCreateGoal = () => {
  return useCustomMutation([QUERY_KEYS.goals], ENDPOINTS.createGoal);
};

export const useUpdateGoal = () => {
  return useCustomMutation([QUERY_KEYS.goals], ENDPOINTS.updateGoal);
};

export const useUpdateGoalKeyResults = () => {
  return useCustomMutation([QUERY_KEYS.goals], ENDPOINTS.updateGoalKeyResults);
};

export const useGetGoal = (goalId: string) => {
  return useQuery([QUERY_KEYS.goals, goalId], () => ENDPOINTS.getGoal(goalId), {
    enabled: !!goalId,
    select: (data) => data?.dto,
  });
};
